import { useGetAllAnomalyDocuments } from '../../hooks/useGetAllAnomalyDocuments';
import { AnomalyDocumentList } from './AnomalyDocumentList';

export const AnomalyDocuments = () => {
  const { documents } = useGetAllAnomalyDocuments();

  return <AnomalyDocumentList documents={documents} />;
};
